import React, { use, useEffect } from "react";
import { View, Text, TouchableOpacity, StyleSheet, Modal } from "react-native";
import { primaryDark } from "../../../Constants/Colors";

const PlayCompanyIntro = ({ isVisible, onClose }) => {
  const [test, setTest] = React.useState("loading");
  useEffect(() => {
    setTest("Component Mounted");
  }, []);

  return (
    <Modal visible={true} transparent={true} animationType="fade" onRequestClose={onClose}>
      <TouchableOpacity style={styles.modalOverlay} onPress={onClose}>
        <TouchableOpacity style={styles.modalContent}>
          {/* Close Button */}
          <TouchableOpacity style={styles.closeButton} onPress={onClose}>
            <Text style={styles.closeText}>✕</Text>
          </TouchableOpacity>

          {/* Video Player */}
          <video
            src="https://files.instantdigits.com/company/CompanyIntro.mp4"
            controls
            autoPlay
            style={{
              width: "100%",
              height: "100%",
              borderRadius: 16,
              backgroundColor: "#000",
            }}
          />
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.49)",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },

  modalContent: {
    width: "90%",
    maxWidth: 1200,
    aspectRatio: 16 / 9,
    position: "relative",
    borderRadius: 16,
    overflow: "hidden",
    borderWidth: 2,
    borderColor: "hsla(0, 0%, 100%, 1.00)",
    shadowColor: primaryDark,
    shadowOffset: { width: 0, height: 20 },
    shadowOpacity: 0.5,
    shadowRadius: 60,
    elevation: 20,
  },

  closeButton: {
    position: "absolute",
    top: 20,
    right: 20,
    zIndex: 10,
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: "#FFFFFF",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    cursor: "pointer",
  },

  closeText: {
    fontSize: 28,
    fontWeight: "700",
    color: primaryDark,
    lineHeight: 28,
  },
});

export default PlayCompanyIntro;
